import { StackedModal } from "@/components/modal/stacked-modal";
import SubscriptionManagementPage from "@/features/user-profile/pages/subscription-management";
import SubscriptionUpgradePage from "@/features/user-profile/pages/subscription-upgrade";
import { memo } from "react";
import { MemoryRouter, Route, Switch, useHistory } from "react-router-dom";

interface MembershipModalProps {
  isOpen: boolean;
  onDismiss: () => void;
}

const MembershipModalContent = memo(function MembershipModalContent({
  isOpen,
  onDismiss,
}: MembershipModalProps) {
  const history = useHistory();

  return (
    <StackedModal
      isOpen={isOpen}
      onDidDismiss={onDismiss}
      showHeader={false}
      forceOverscroll={false}
    >
      <Switch>
        <Route
          exact
          path="/"
          render={() => <SubscriptionManagementPage onBack={onDismiss} />}
        />
        <Route
          path="/subscriptions/upgrade"
          render={() => <SubscriptionUpgradePage onBack={() => history.goBack()} />}
        />
      </Switch>
    </StackedModal>
  );
});

export const MembershipModal = memo(function MembershipModal({
  isOpen,
  onDismiss,
}: MembershipModalProps) {
  return (
    <MemoryRouter initialEntries={["/"]} key={isOpen ? "open" : "closed"}>
      <MembershipModalContent isOpen={isOpen} onDismiss={onDismiss} />
    </MemoryRouter>
  );
});
